import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const [copied, setCopied] = useState(false);

  const handleCopyEmail = async () => {
    try {
      await navigator.clipboard.writeText('xoxo@inflection.pro');
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy email:', err);
    }
  };

  return (
    <footer className="footer">
      <div className="footer-content">
        <span className="footer-copyright">&copy; {new Date().getFullYear()} Inflection</span>
        <button className="footer-email" onClick={handleCopyEmail} title="Copy email address">
          {copied ? 'Copied!' : 'xoxo@inflection.pro'}
        </button>
        <Link className="footer-link" to="/legal/privacy">Privacy</Link>
        <Link className="footer-link" to="/legal/terms">Terms</Link>
      </div>
    </footer>
  );
};

export default Footer;
